import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HistoryComponent } from "./history.component";
import { SharedModule } from "../shared/shared.module";
import { HistoryDirective } from "./history.directive";
import { HistoryItemComponent } from "./history-item/history-item.component";
import { HistoryRowComponent } from "./history-row/history-row.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { ButtonModule, IconModule, PipesModule, ReferenceModule } from "@recore-solutions/nstar-lib";
import { ConfirmDeletionModalComponent } from "./confirm-deletion-modal/confirm-deletion-modal.component";
import { HistoryDiffDirective } from "../shared/history-diff.directive";

@NgModule({
	declarations: [
		HistoryComponent,
		HistoryDirective,
		HistoryItemComponent,
		HistoryRowComponent,
		ConfirmDeletionModalComponent,
		HistoryItemComponent,
		HistoryRowComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		NgbModule,
		NgbNavModule,
		ButtonModule,
		IconModule,
		PipesModule,
		ReferenceModule,
		HistoryDiffDirective,
	],
	exports: [HistoryComponent, HistoryDirective],
})
export class HistoryModule {
	static forRoot(): ModuleWithProviders<HistoryModule> {
		return {
			ngModule: HistoryModule,
		};
	}
}
